import React, { useEffect, useRef, useState } from "react";
import {
  HStack,
  Image,
  Stack,
  useToast,
} from "@chakra-ui/react";
import GridView from "./Library/GridView";
import { useNavigate, useParams } from "react-router-dom";
import { totalFilterCount } from "../../util/helper";
import * as getBibliographyData from "../../services/Bibliography";
// import SortBy from "../../CommonComponents/Filter/SortBy";
import { updateFacetsData } from "../../util/helper";
import { handleApiError, showSuccessToast } from "../../util/errorHandler";
import { toastMessages } from "../../constants/constants";
import { updateHighlightData } from "../../services/Libraries";

const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

export const Archive = ({
  visible,
  handleBookClick,
  setleftFlag,
  openDrawer,
  setOpenDrawer,
  tableName,
  masterlist,
  setLibraryCount,
  masterlistType = "generic",
  filerStyle,
  onCountLoad
}) => {
  const [contentClicked, setContentClicked] = useState(false);
  const [scanClicked, setScanClicked] = useState(false);
  const [showFilterBox, setShowFilterBox] = useState(false);
  const [swiper, setSwiper] = useState(null);
  const [apply, setApply] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { bookAlias } = useParams();
  const [firstTimeLoaded, setFirstTimeLoaded] = useState(false);
  const [filteredResultCount, setFilteredResultCount] = useState(0);
  const [reset, setReset] = useState(false);
  const toast = useToast();
  
  let filterParamsObj = null;


  useEffect(() => {
    if (!firstTimeLoaded) {
      if (filterParamsObj) {
        setFilterOptions(filterParamsObj);
        setSearchTerm(filterParamsObj?.search);
        setApply(true);
      }
      setFirstTimeLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterParamsObj]);

  const handleFilterClick = () => {
    setShowFilterBox(!showFilterBox);
  };

  const showSliderImage = (index) => {
    if (swiper) {
      swiper.slideTo(index);
    }
  };

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    filters: {},
    gate: "AND",
    sortBy_v: "sortable_year"
  });

  const [filterPills, setFilterPills] = useState(null);
  
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    handleCheckboxChange("searches", e.target.value);
  };

  const handleCheckboxChange = (value, type) => {
    let selectedArray = [];
    let selectedString = "";  
    switch (value) {
      case "sort":
        selectedString = filterOptions.sortBy_v;
        break;
      case "gate":
        selectedString = filterOptions.gate;
        break;
      case "searches":
        selectedString = filterOptions.search;
        break;
      default:
        if (value in filterOptions.filters) {
          selectedArray = filterOptions.filters[value];
        }
        break;
    }
  
    if (Array.isArray(type)) {
      // Bulk replace (used by FilterBody's "Select All" / clear-all toggle)
      // rather than the usual single-value toggle below.
      selectedArray = type;
    } else if (selectedArray.includes(type)) {
      selectedArray = selectedArray.filter((checkbox) => checkbox !== type);
    } else {
      selectedArray = [...selectedArray, type];
    }
  
    if (selectedString !== type) {
      selectedString = type;
    }
  
    switch (value) {
      case "sort":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          sortBy_v: selectedString,
        }));
        break;
      case "gate":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          gate: selectedString,
        }));
        break;
      case "searches":
        setFilterOptions(prevFilterOptions => ({
          ...prevFilterOptions,
          search: selectedString,
        }));
        break;
      default:
        if (value in filterOptions.filters) {
          setFilterOptions(prevFilterOptions => ({
            ...prevFilterOptions,
            filters: {
              ...prevFilterOptions.filters,
              [value]: selectedArray,
            },
          }));
        }
        break;
    }
  };

  const citationFactor = (data) => {
    return data.map((item) => {
      const imagePath = item?.find((nestedItem) => nestedItem?.key === "direct_url_of_cover_image")?.value || 
                       item?.find((nestedItem) => nestedItem?.key === "direct_url_of_preview_image")?.value || "";
      const firstName = item?.find((nestedItem) => nestedItem?.key === "creator_first_name")?.value;
      const lastName = item?.find((nestedItem) => nestedItem?.key === "creator_surname")?.value;
      const creatorName = item?.find((nestedItem) => nestedItem?.key === "creator_name")?.value;
      const author = lastName && firstName ? `${firstName} ${lastName}` : "";
      const bookKey = item?.find((nestedItem) => nestedItem?.key === "title")?.value || null;
      const book = bookKey;
      const link = item?.find((nestedItem) => nestedItem?.key === "drawer_link")?.value || null;

      const docType = item?.find((nestedItem) => nestedItem?.key === "document_type")?.value || null;
      const typeCreator = item?.find((nestedItem) => nestedItem?.key === "type_of_creator")?.value || null;
      const fullname = creatorName !== "" ? author : creatorName;
      const sliderImage = item?.find((nestedItem) => nestedItem?.key === "drawer_image_alias")?.value || '';
      const bibliograhpic_citation = item?.find((nestedItem) => nestedItem?.key === "bibliograhpic_citation")?.value ||
                                    item?.find((nestedItem) => nestedItem?.key === "bibliographic_citation")?.value || "";
      const bibliograhpic_caption = item?.find((nestedItem) => nestedItem?.key === "bibliographic_caption")?.value || "";
      const desc = bibliograhpic_citation || "";
      const listDesc = bibliograhpic_caption || '';
      const alias = item?.find((nestedItem) => nestedItem?.key === "alias")?.value;
      const title = item?.find((nestedItem) => nestedItem?.key === "title")?.value;
      const header = `${title ? title : ''}`;
      const publisher = item?.find((nestedItem) => nestedItem?.key === "place_of_publication")?.value;
      const bookCaption = item?.find((nestedItem) => nestedItem?.key === "book_caption")?.value || null;
      const publicationYear = item?.find((nestedItem) => nestedItem?.key === "sortable_year")?.value || null;
      const firstEdition = item?.find((nestedItem) => nestedItem?.key === "date_of_first_edition")?.value || null;
      const details_page = item?.find((nestedItem) => nestedItem?.key === "details_page")?.value;
      const highlight = item?.find((nestedItem) => nestedItem?.key === "highlight")?.value;
      return {
        imagePath,
        desc,
        header,
        bookKey,
        link,
        typeCreator,
        book,
        author,
        docType,
        sliderImage,
        fullname,
        alias,
        title,
        publisher,
        bookCaption,
        publicationYear,
        firstEdition,
        listDesc,
        details_page: details_page?.toLowerCase() === "no" ? false : true,
        highlight,
        body: [
          {
            text: "Index Page →",
          }
        ],
        footer: [
          {
            text: "Contents Page→",
          },
          {
            text: "Selected Pages→",
          },
        ]
      };
    });
  };

  const [facets, setFacets] = useState([]);
  const [sort, setSort] = useState([]);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const { alias } = useParams();
  const initialLoadComplete = useRef(false);

  async function fetchData() {
    if (!navigator.onLine) {
      alert("No network connection. Please check your internet connection and try again.");
      return;
    }
    try {
      setIsLoading(true);
      const result = await getBibliographyData.archiveByMasterlist(
        alias,
        masterlistType,
        filterOptions,
        page
      );
      setIsLoading(false);
      if (result && result?.data && result?.data.length > 0 && filterParamsObj === null) {
        const processedData = citationFactor(result?.data);
        setData(processedData);
        if (!initialLoadComplete.current) {
          setPage((prevPage) => prevPage + 1);
          initialLoadComplete.current = true;
          if (onCountLoad) onCountLoad(result?.total || processedData.length);
        }
        if (result?.facetsHeaders && result?.facets) {
          const formattedFacets = updateFacetsData({ data: result });
          setFacets(formattedFacets);
        
          if (formattedFacets && formattedFacets.length > 0) {
            setFilterOptions((prevFilterOptions) => ({
              ...prevFilterOptions,
              filters: {
                ...prevFilterOptions.filters,
                ...formattedFacets.reduce((acc, facet) => {
                  acc[facet.key] = [];
                  return acc;
                }, {}),
              },
            }));
          }
        }
        
        if (result?.total && result?.data?.length && result.total === result.data.length) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }

        const sortedFacets = result?.sortByHeader?.map((obj) => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);
      } else if (result && (!result?.data || result?.data.length === 0)) {
        setData([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    setFilterPills(filterOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMoreData = async () => {
    if (!navigator.onLine) {
      alert("No network connection. Please check your internet connection and try again.");
      return;
    }
    if (!hasMore || isLoading) {
      return;
    }
    try {
      const result = await getBibliographyData.archiveByMasterlist(
        alias,
        masterlistType,
        filterOptions,
        page
      );

      if (result && result?.data && result?.data.length > 0) {
        const processedData = citationFactor(result?.data);
        setData((prevData) => [...prevData, ...processedData]);
        setPage((prevPage) => prevPage + 1);
        const sortedFacets = result?.sortByHeader?.map((obj) => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);
        
        // Check if we've loaded all data
        const currentTotal = data.length + processedData.length;
        if (currentTotal >= result?.total || result?.data.length < result?.page_size) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasMore(false);
    }
  };

  async function fetchFilterData(page = 1) {
    try {
      setIsLoading(true);
      const result = await getBibliographyData.archiveByMasterlist(
        alias,
        masterlistType,
        filterOptions,
        page
      );
      setIsLoading(false);

      if (result) {
        const processedData = result?.data && result?.data.length > 0 ? citationFactor(result?.data) : [];
        setData(processedData);
        setPage(prev => prev + 1);
        const sortedFacets = result?.sortByHeader?.map((obj) => {
          const key = Object.keys(obj)[0];
          return { key: key, display: obj[key] };
        });
        setSort(sortedFacets);
        const filtercnt = totalFilterCount(filterOptions?.filters);
        if (filtercnt > 0 || filterOptions?.search) {
          setFilteredResultCount(result?.total || 0);
        } else {
          setFilteredResultCount(0);
        }
        if (result?.data?.length && result?.total && result.data.length === result.total) {
          setHasMore(false);
        } else if (result?.data?.length > 0) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }

        if (result?.facetsHeaders && result?.facets) {
          const formattedFacets = updateFacetsData({ data: result });
          setFacets(formattedFacets);
          if (formattedFacets && formattedFacets.length > 0 && reset) {
            setFilterOptions((prevFilterOptions) => ({
              ...prevFilterOptions,
              filters: {
                ...prevFilterOptions.filters,
                ...formattedFacets.reduce((acc, facet) => {
                  acc[facet.key] = [];
                  return acc;
                }, {}),
              },
            }));
            setReset(false);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (apply) {
      window.scrollTo(0, 0);
      setApply(false);
      setHasMore(true);
      setPage(1);
      fetchFilterData();
      setFilterPills(filterOptions);
    }
    const filtercnt = totalFilterCount(filterOptions?.filters);
    setFilterCount(filtercnt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apply]);

  const handleReset = () => {
    setFilteredResultCount(0);
    const initializedFilters = facets.reduce((acc, facet) => {
      acc[facet.key] = [];
      return acc;
    }, {});
    setFilterOptions({
      search: "",
      filters: initializedFilters,
      sortBy_v: "sortable_year",
      gate: "AND"
    });
    setFilterCount(0);
    setSearchTerm("");
    setReset(true);
  };

  // Handler function for checkbox changes - can be customized for API calls
  const handleItemCheckboxChange = async (item, isChecked) => {
    try {
      // Determine type from URL path
      const type = window.location.pathname.split('/')[1];
      
      // Convert boolean to 'yes'/'no'
      const highlightValue = isChecked ? 'yes' : 'no';
      
      // Use common function with type parameter
      if (type === 'libraries' || type === 'archive') {
        await updateHighlightData(item.alias, highlightValue, type, alias);
      } else {
        // Fallback to old method if type is not recognized
        await getBibliographyData.updateArchiveHighlight(item.alias, isChecked, alias);
      }
      
      const message = isChecked 
        ? toastMessages.ITEM_SELECTED_AS_HIGHLIGHT 
        : toastMessages.ITEM_NOT_HIGHLIGHTED;
      showSuccessToast(toast, message);
    } catch (error) {
      console.error("Error handling checkbox change:", error);
      handleApiError(error, toast, {
        defaultErrorMessage: toastMessages.FAILED_TO_UPDATE_HIGHLIGHT_STATUS
      });
    }
  };
  const navigate = useNavigate();
  const handleItemNavigation = (item) => {
    navigate(`/archive/${item?.alias}`);
  };

  return (
    <>
      {!isLoading ? (
        <Stack position={"relative"}>
          {/* {sort && sort?.length > 0 && data && data?.length > 0 &&  
            <SortBy
              sort={sort}
              masterlistType={masterlistType}
              filterOptions={filterOptions}
              handleCheckboxChange={handleCheckboxChange}
              setApply={setApply}
            />
          } */}
            <>
              <GridView
                openDrawer={openDrawer}
                filterPills={filterPills}
                setFilterPills={setFilterPills}
                setOpenDrawer={setOpenDrawer}
                handleBookClick={handleBookClick}
                contentClicked={contentClicked}
                scanClicked={scanClicked}
                setContentClicked={setContentClicked}
                setScanClicked={setScanClicked}
                setleftFlag={setleftFlag}
                tableName={tableName}
                masterlist={masterlist}
                setLibraryCount={setLibraryCount}
                masterlistType={masterlistType}
                fetchMoreData={fetchMoreData}
                data={data}
                showFilterBox={showFilterBox}
                handleFilterClick={handleFilterClick}
                hasMore={hasMore}
                setShowFilterBox={setShowFilterBox}
                setApply={setApply}
                sort={sort}
                handleCheckboxChange={handleCheckboxChange}
                handleSearch={handleSearch}
                filterOptions={filterOptions}
                filteroptionData={facets}
                setFilterOptions={setFilterOptions}
                setSearchTerm={setSearchTerm}
                filterCount={filterCount}
                searchTerm={searchTerm}
                handleReset={handleReset}
                bookAlias={bookAlias}
                filerStyle={filerStyle}
                setSwiper={setSwiper}
                filteredResultCount={filteredResultCount}
                showSliderImage={showSliderImage}
                enableCheckbox={true}
                handleItemCheckboxChange={handleItemCheckboxChange}
                handleItemNavigation={handleItemNavigation}
              />
            </>
        </Stack>
      ) : (
        <HStack justifyContent={"center"} minH={"100vh"} alignItems={"flex-start"} mt={4}>
          <Image src={loaderImg} width={"100px"} height={"100px"} alt="Loading" />
        </HStack>
      )}
    </>
  );
};

export default Archive;
